import React from "react"

const Spinner: React.FC<{
  searching: boolean
  inModal?: boolean
}> = ({ searching, inModal }) => {
  return (
    <div
      style={{
        left: inModal ? "0" : undefined,
      }}
      className={searching ? "spinner fade is-show" : "spinner fade"}></div>
  )
}
export default Spinner
